import React, { useState } from 'react';
import { Modal, Space, Alert, Input } from 'antd';

const { TextArea } = Input;

const NovedadModal = ({ visible, onCancel, onConfirm, diferencia }) => {
  const [localNovedad, setLocalNovedad] = useState('');

  const handleConfirm = () => {
    onConfirm(localNovedad);
    setLocalNovedad('');
  };

  return (
    <Modal
      title="Registrar Novedad"
      open={visible}
      onCancel={() => {
        setLocalNovedad('');
        onCancel();
      }}
      onOk={handleConfirm}
      okButtonProps={{ disabled: !localNovedad }}
    >
      <Space direction="vertical" style={{ width: "100%" }}>
        <Alert
          message={`Diferencia detectada: $${Math.abs(diferencia).toLocaleString()}`}
          type="warning"
          showIcon
        />
        <TextArea
          rows={4}
          value={localNovedad}
          onChange={(e) => setLocalNovedad(e.target.value)}
          placeholder="Escriba la novedad aquí..."
        />
      </Space>
    </Modal>
  );
};

export default NovedadModal;